import { AttachmentFile, WipAttachmentFileType, WorkInProgressStatementId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminWipStatementAttachmentsQueryKey } from "../financial-statement.keys";

export const useAdminGetWipStatementAttachments = (wipStatementId: WorkInProgressStatementId) => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: adminWipStatementAttachmentsQueryKey(wipStatementId),
		queryFn: async () => {
			return await get<AttachmentFile<WipAttachmentFileType>[]>(
				`/v2/admin/surety/wip-statement/${wipStatementId}/attachments`,
			);
		},
	});

	return {
		wipStatementAttachments: query.data,
		wipStatementAttachmentsIsLoading: query.isLoading,
		wipStatementAttachmentsError: query.error,
		wipStatementAttachmentsSuccess: query.isSuccess,
	};
};
